<img *ngIf="thumb()" class="xp-file-row__thumb" [src]="thumb()" [alt]="name()" />
<div class="xp-file-row__body">
	<img *ngIf="iconSrc()" class="xp-file-row__icon" [src]="iconSrc()" alt="" />
	<div class="xp-file-row__text">
		<div class="xp-file-row__name" [title]="name()">{{ name() }}</div>
		<div *ngIf="caption()" class="xp-file-row__caption">{{ caption() }}</div>
	</div>
</div>
<img *ngIf="removeIconSrc()"
     class="xp-file-row__remove-image"
     [src]="removeIconSrc()"
     [alt]="removeLabel()"
     (click)="remove.emit()" />
<button *ngIf="removeIcon()"
        mat-icon-button
        type="button"
        class="xp-file-row__remove"
        [attr.aria-label]="removeLabel()"
        (click)="remove.emit()">
	<mat-icon>{{ removeIcon() }}</mat-icon>
</button>
